import { useTranslation } from "@outschool/localization";
import React, { useEffect, useState } from "react";

import { LearnerFormWarning } from "./LearnerFormWarning";

type LearnerNameWarningProps = {
  name: string;
  maxLength?: number;
};

export const LearnerNameRegex = new RegExp(
  /(^[A-Za-z]{2,})([ ]{1,})([A-Za-z]{1,})/,
);

export const LEARNER_NAME_MAX_LENGTH = 30;

export function LearnerNameWarning({
  name,
  maxLength = LEARNER_NAME_MAX_LENGTH,
}: LearnerNameWarningProps) {
  const { t } = useTranslation(
    "client\\components\\learner\\LearnerNameWarning",
  );
  const [showSpaceInNameWarning, setShowSpaceInNameWarning] = useState(false);
  const [showNameTooLongWarning, setShowNameTooLongWarning] = useState(false);

  useEffect(() => {
    setShowSpaceInNameWarning(LearnerNameRegex.test(name));
    setShowNameTooLongWarning(name.length > maxLength);
  }, [name, maxLength]);

  if (showNameTooLongWarning) {
    return (
      <LearnerFormWarning
        message={t(
          "We only support first names up to {{maxLength}} characters.",
          { maxLength },
        )}
      />
    );
  }

  if (showSpaceInNameWarning) {
    return (
      <LearnerFormWarning
        message={t(
          "We suggest entering first name only to protect your learner’s privacy.",
        )}
      />
    );
  }

  return null;
}
